import { fabric } from 'fabric'
import { makerSVGContent } from './Marker'

const CommentShape = (
    fabricCanvas,
    setIsMarkToolRelease,
    setCommentCanvasId,
    setCommentPositionNumber
) => {
    console.log('CommentDrawing')

    let pointer
    let identifier

    const generateIdentifier = () => {
        identifier = `markingTool-${Math.random().toString(36).substr(2, 9)}`
    }

    const originalToObject = fabric.Object.prototype.toObject
    const myAdditional = ['markerNumber', 'identifier']
    fabric.Object.prototype.toObject = function (additionalProperties) {
        return originalToObject.call(
            this,
            myAdditional.concat(additionalProperties)
        )
    }

    fabricCanvas.on('mouse:down', (o) => {
        if (!fabricCanvas.isDrawingSinglePointMarkMode) return
        pointer = fabricCanvas.getPointer(o.e)
        generateIdentifier()
        fabric.loadSVGFromString(
            makerSVGContent(commentNumber.toString()),
            (objects, options) => {
                const obj = fabric.util.groupSVGElements(objects, options)
                obj.set({ left: pointer.x - 20, top: pointer.y - 40 })
                obj.set('markerNumber', `markingTool_${commentNumber}`)
                obj.set('identifier', identifier)
                obj.strokeUniform = true
                obj.hasControls = false
                obj.hasBorders = false
                obj.strokeLineJoin = 'miter'
                obj.getObjects()[3].left =
                    commentNumber.toString().length > 1 ? -12 : -5
                obj.getObjects()[3].top = -15
                fabricCanvas.add(obj).requestRenderAll()
                setIsMarkToolRelease(true)
                setCommentCanvasId(fabricCanvas.getElement().id)
                setCommentPositionNumber(commentNumber)
                fabricCanvas.calcOffset()
                fabricCanvas.fire('object:modified')
                fabricCanvas.setActiveObject(obj)
            }
        )
    })

    fabricCanvas.on('mouse:down', (o) => {
        const actObj = fabricCanvas?.getActiveObject()
        if (
            !fabricCanvas.isDrawingSinglePointMarkMode &&
            actObj?.markerNumber
        ) {
            actObj.hasControls = false
            actObj.hasBorders = false
            const commentNumber = actObj.markerNumber.split('_')[1]
            setIsMarkToolRelease(true)
            setCommentCanvasId(fabricCanvas.getElement().id)
            setCommentPositionNumber(commentNumber)
        }
    })

    fabricCanvas.on('mouse:down', (o) => {
        const actObj = fabricCanvas?.getActiveObject()
        if (
            !fabricCanvas.isDrawingSinglePointMarkMode &&
            actObj?.type === 'group' &&
            actObj._objects.length === 2 &&
            actObj._objects[0].type === 'circle' &&
            actObj._objects[1].type === 'text'
        ) {
            fabric.Group.prototype.hasControls = false
            fabric.Group.prototype.hasBorders = false
            const commentNumber = actObj._objects[1].text
            setIsMarkToolRelease(true)
            setCommentCanvasId(fabricCanvas.getElement().id)
            setCommentPositionNumber(commentNumber)
        } else {
            fabric.Group.prototype.hasControls = true
            fabric.Group.prototype.hasBorders = true
        }
    })
}

export default CommentShape
